export default {
  header: {
    earn_points_get_free_rewards: "{{count}} points = rewards",
    upload_google_review_get_free_rewards: "Review = rewards",
  },
  reward_card: {
    title: "Get discounts & free food",
    earn_points: "Earn points whenever you spend {{threshold}}",
  },
  enter_phone_number: {
    title: "Your mobile number",
    description:
      "We need your phone number, so that we can make sure you are the right person that we reward",
    place_holder: "Phone",
  },
  button: {
    continue: "Continue",
  },
  product_suggestions: {
    loyalty: {
      title: "Points for discounts & free food",
      description: "Earn points for discounts & free food",
    },
    googleReview: {
      title: "Rate us & get",
    },
  },
};
